import getApiModuleHost from '../helpers/__api-base/getApiModuleHost';
import getApiPath from '../helpers/__api-base/getApiPath';
import getEntityApiInfo from '../helpers/__api-base/getEntityApiInfo';

/**
 *
 */
export default function getEntityApiBase({
  apiSettings,
  basePath,
  entityName,
  // hostName,
  isLogEnabled,
  isRequestUrlPure,
  target,
  usingProxy,
}: {
  apiSettings: Record<string, any>;
  basePath: string;
  entityName: string;
  // hostName: string;
  isLogEnabled?: boolean;
  isRequestUrlPure?: boolean;
  target: string;
  usingProxy: boolean;
}) {
  // console.group('getEntityApiBase');

  /*  */
  const { entitiesModulesMap, hosts, hostsProxyMap, modulesHostsMap } =
    apiSettings;

  /*  */
  const entityApiInfo = getEntityApiInfo(entityName, {
    entitiesModulesMap,
    hosts,
    modulesHostsMap,
  });
  const apiModuleData = entityApiInfo.module;

  /* Host */
  let host = getApiModuleHost({ apiModuleData, hostsProxyMap, usingProxy });
  if (host === undefined /*  || apiModuleData.hostName === hostName */) {
    host = '';
  }

  /* Path */
  const requestUrl =
    host +
    getApiPath(entityName, target, entityApiInfo, hostsProxyMap, usingProxy);

  /*  */
  const proxyPath = basePath + '/' + entityName;
  isLogEnabled &&
    console.log('[getEntityApiBase] ' + proxyPath + ' => ' + requestUrl);

  const result = isRequestUrlPure ? requestUrl : proxyPath;

  // console.log('requestUrl', requestUrl, 'proxyPath', proxyPath);
  // console.groupEnd('getEntityApiBase');

  return result;
}
